import type { BuilderConfig } from '@/types/builder';
import BtnConfig from './Btn/Btn.builder';
import BtnCtaConfig from './BtnCta/BtnCta.builder';
import HeadTagsConfig from './HeadTags/HeadTags.builder';
import SearchGlobalHeroConfig from './SearchGlobalHero/SearchGlobalHero.builder';

export const builderComponents: BuilderConfig[] = [
    BtnConfig,
    BtnCtaConfig,
    HeadTagsConfig,
    SearchGlobalHeroConfig,
];
